import api from '@/services/api';

const smrPath = '/smr';

// Write-only: this DTO is the ONLY shape the backend ever returns for this
// resource. There is no `api_key` field here or anywhere else on the wire.
export interface SmriqCredentialStatus {
    has_key: boolean;
    last4: string | null;
    division: string | null;
    updated_at: string | null;
}

export interface SmriqCredentialPayload {
    api_key: string;
    division: string;
}

// Field-by-field, not a cast: an unvalidated `.data.data` passthrough would let an
// extra wire field (e.g. a regressed plaintext key) ride straight into the query cache.
const toStatus = (raw: SmriqCredentialStatus): SmriqCredentialStatus => ({
    has_key: raw.has_key,
    last4: raw.last4,
    division: raw.division,
    updated_at: raw.updated_at,
});

export const fetchSmriqCredential = async (productId: string): Promise<SmriqCredentialStatus> =>
    toStatus((await api.get<{ data: SmriqCredentialStatus }>(`${smrPath}/products/${productId}/smriq-credentials`)).data.data);

export const upsertSmriqCredential = async (
    productId: string,
    payload: SmriqCredentialPayload,
): Promise<SmriqCredentialStatus> =>
    toStatus((await api.put<{ data: SmriqCredentialStatus }>(`${smrPath}/products/${productId}/smriq-credentials`, payload)).data.data);

export const deleteSmriqCredential = async (productId: string): Promise<SmriqCredentialStatus> =>
    toStatus((await api.delete<{ data: SmriqCredentialStatus }>(`${smrPath}/products/${productId}/smriq-credentials`)).data.data);
